module.exports = __webpack_public_path__ + "img/no-data-Ahex_predel.357d6c13.png";